module.exports = __webpack_public_path__ + "img/brick-horizontal.857f4071.svg";